import './App.css';
import './style/home.css'
import './style/services.css'
import './style/projects.css'
import './style/about-us.css'
import './style/contact-us.css'
import logo from './imgs/4ever-logo.png'
import icon from './imgs/roller.jpg'
import bkg_home from './imgs/background_home.png'

// Images imported for services section
import int_painting from './imgs/p10.png'
import ext_painting from './imgs/p12.png'
import ind_painting from './imgs/p2.png'
import power_washing from './imgs/power-washing.jpg'
import cabinet_paint from './imgs/cabinet-paint.jpg'
import special_paint from './imgs/p8.png'

// Images imported for project section
import proj1 from './imgs/ext-2.jpg' 
import proj2 from './imgs/ext-3.jpg' 
import proj3 from './imgs/ext-4-alt.jpg' 
import proj4 from './imgs/int-2.jpg' 
import proj5 from './imgs/int-4.jpg' 
import proj6 from './imgs/int-5.jpg' 

import React, { useState } from 'react'

document.title = "4ever Good Painting"

function Header() {
   const [sidebarOpen, setSidebarOpen] = useState(false);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleScrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setSidebarOpen(false); // Close sidebar after navigation
  };

  return (
    <header className="header">
      <div className="content">
        <h1 className="title">
          <img src={icon} alt="4Ever Good Painting" className="logo" />
          4ever Good Painting
        </h1>
        
        {/* Sidebar overlay for small screens */}
        <nav className={`sidebar ${sidebarOpen ? 'active' : ''}`}>
          <span className="close-btn" onClick={toggleSidebar}>&times;</span>
          <a href="#home" onClick= {() => handleScrollToSection('home')}>Home</a>
          <a href="#services" onClick={() => handleScrollToSection('services')}>Services</a>
          <a href="#projects" onClick={() => handleScrollToSection('projects')}>Projects</a>
          <a href="#about" onClick={() => handleScrollToSection('about')}>About Us</a>
          <a href="#contact" onClick={() => handleScrollToSection('contact')}>Contact Us</a>
        </nav>
        
        {/* Burger menu icon */}
        <div className="burger-menu" onClick={toggleSidebar}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </header>
  );
}

// Home Section component
function Home() {
  return (
    <section id = "home" className="home">
      <img src={bkg_home} alt="nothing" className='bkg_home' />
      <div className='main_text'>
        <h2><span>Transform Your Space with</span><span>4Ever Good Painting</span></h2>
        <p>Professional interior and exterior painting services that bring your vision to life.</p>
        {/* <a href="/contact" className="cta-button">Get a Free Quote</a> */}
      </div>
    </section>
 );
}

// Services Section component
function Services() {
  return (
    <section id = "services" className="services">
      <h2>Our Services</h2>
      <div className="service-list">
        <Service title="Interior Painting" description="Enhance your home's interior with our expert painting services for walls, ceilings, and more." image={int_painting} />
        <Service title="Exterior Painting" description="Make your property stand out with a fresh, durable exterior paint." image={ext_painting} />
        <Service title="Commercial Painting" description="Professional painting services for offices, retail spaces, and other commercial properties."  image={ind_painting} />
        <Service title="Specialized Washing" description="Revitalize your driveways, roofs, and other surfaces with our power washing service." image={power_washing} />
        <Service title="Cabinet Painting" description="Transform your kitchen or bathroom cabinets with a fresh finish." image={cabinet_paint} />
        <Service title="Specialized Painting" description="Decorate your space with differnt textures and accent walls." image={special_paint} />
      </div>
    </section>
  );
}

// Service item component (used in Services section)
function Service({ title, description, image}) {
  return (
    <div className="service">
      <img src={image} alt="Service Sample" className="sample1" />
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}

// Projects Section component
function Projects() {
  return (
    <section id = "projects" className="projects">
      <h2>Our Projects</h2>
      <p>Check out our recent projects to see the transformation of our work.</p> <br></br>
      <div class="container">
        <div className="project-grid">
          <Project title="" description="" image={proj1} />
          <Project title="" description="" image={proj2} />
          <Project title="" description="" image={proj3} />
          <Project title="" description="" image={proj4} />
          <Project title="" description="" image={proj5} />
          <Project title="" description="" image={proj6} />
        </div>
      </div>
    </section>
  );
}

// Project item component (used in Projects section)
function Project({title, description, image}) {
  return (
    <div class="project stacked">
      <img src={image} alt="nothing to show" className="img_proj" />
      <div class="project__content">
        <h2 class="project__title">{title}</h2>
        <p class="showcase"></p>
        <p class="proj__description">{description}</p>
      </div>
    </div>
  );
}

// About Us Section component
function AboutUs() {
  return (
    <section id = "about" className="about-us">
      <h2>About Our Company </h2>
      <p> With more than 10 years of experience at 4ever Good Painting we are dedicated to delivering high-quality painting services tailored to your needs, ensuring satisfaction with every project we undertake.</p>
      <a href="#projects" className="cta-button">View Projects</a>
    </section>
  );
}

// Contact Us Section component
function ContactUs() {
  return (
    <section id = "contact" className="contactus">
      <h2>Contact Us</h2>
      <div id="contact-info">
        <div class="contact-item" id="logo">
          <img src={logo} alt="4ever Good Painting" className="company-logo" />
        </div>
        <div class="contact-item" id="contact-details">
          <div class="contact-detail">
            <span class="icon">&#9990; </span> 
            <a href="tel:+1234567890" class="contact-text"> &nbsp;+1(415)574-8158</a>
          </div>
          <div class="contact-detail">
            <span class="icon">&#9993; </span> 
            <a href="mailto:4evergoodpainting@gmail.com" class="contact-text"> &nbsp;4evergoodpainting@gmail.com</a>
          </div>
        </div>
      </div>      

      <p> &nbsp;&copy; 2024 4Ever Good Paiting Inc. 
        {/* <a href="/privacy-policy" target="_blank">Privacy Policy</a> | 
        <a href="/cookie-policy" target="_blank">Cookie Policy</a> */}
      </p>
    </section>
  );
}

// function Footer () {
//   return (
//     <footer className= "policies">
//   <p>&copy; 2024 Your Company. <a href="/privacy-policy" target="_blank">Privacy Policy</a> | <a href="/cookie-policy" target="_blank">Cookie Policy</a></p>
// </footer>
//   );

// }
// Main App component
function App() {
  return (
    <div>
      <Header />
      <Home />
      <Services />
      <Projects />
      <AboutUs />
      <ContactUs />  
      {/* <Footer /> */ }
    </div>
  );
}

export default App;

// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
